// @flow

import { Store } from '@homie/flux';
import {
  DASHBOARD_DATA_CHANGE,
  DASHBOARD_LOADING,
  DASHBOARD_UPDATE_QUERY_STRING,
  DASHBOARD_UPDATE_STATUS,
  DASHBOARD_UPDATE_APPLICATION,
  DASHBOARD_UPDATE_ACTIVE_STEP
} from 'modules/dashboards/api/action_types/DashboardActionTypes';
import Dispatcher from 'dispatcher';
import { values } from 'lodash';
import qs from 'query-string';

let state = {
  queryString: null,
  applications: {},
  meta: {},
  isLoading: false,
  queryObject: {},
  isNullQueryObject: true,
  totals: {
    approved: 0,
    declined: 0,
    documents_requested: 0,
    pending: 0,
    pending_payment: 0,
    screening: 0,
    pages: 0
  }
};

class DashboardApplicationsStore extends Store {
  constructor(): void {
    super();
    Dispatcher.register(this._reducer);
  }

  get isLoading() {
    return state.isLoading;
  }

  get applications() {
    return values(state.applications);
  }

  get meta() {
    return state.meta;
  }

  get totals() {
    return state.totals;
  }

  get queryObject() {
    return {
      ...state.queryObject,
      active_step: state.queryObject.active_step || 'screening',
      page: state.queryObject.page ? +state.queryObject.page : 1,
      per_page: 9
    };
  }

  get isNullQueryObject() {
    return state.isNullQueryObject;
  }

  _mapApplications = (applications: any) =>
    applications.reduce((accumulator, application) => {
      accumulator[application.id] = application;
      return accumulator;
    }, {});

  _mapTotals = (meta: any) => ({
    approved: meta?.total_approved,
    declined: meta?.total_declined,
    documents_requested: meta?.total_documents_requested,
    pending: meta?.total_pending,
    pending_payment: meta?.total_pending_payment,
    screening: meta?.total_screening,
    pages: meta?.total_pages
  });

  _updateApplicationsByParams = (
    applicationId: any,
    property: string,
    value: any
  ) => {
    state.applications[applicationId][property] = value;
  };

  _reducer = (action: any) => {
    switch (action.type) {
      case DASHBOARD_DATA_CHANGE: {
        state = {
          ...state,
          applications: this._mapApplications(action.applications),
          meta: action.meta,
          isLoading: action.isLoading,
          totals: this._mapTotals(action.meta)
        };
        break;
      }
      case DASHBOARD_LOADING: {
        state = { ...state, isLoading: action.isLoading };
        break;
      }
      case DASHBOARD_UPDATE_QUERY_STRING: {
        state = {
          ...state,
          queryString: action.queryString,
          queryObject: qs.parse(action.queryString),
          isNullQueryObject: false
        };
        break;
      }
      case DASHBOARD_UPDATE_STATUS: {
        state.meta.current_status = action.status;
        state.queryObject.current_status = action.status;
        break;
      }
      case DASHBOARD_UPDATE_APPLICATION: {
        this._updateApplicationsByParams(
          action.applicationId,
          action.property,
          action.value
        );
        break;
      }
      case DASHBOARD_UPDATE_ACTIVE_STEP: {
        state.queryObject.active_step = action.activeStep;
        break;
      }
    }
    this.notify();
  };
}

export default new DashboardApplicationsStore();
